import AppColorPicker from "elements/AppColorPicker";
import { useState, useEffect } from "react";
import Constants from "utils/Constants";
import AppModal from "./AppModal";

const ColorModal = ({
  open,
  onClose,
  existingColor = Constants.THEME.PRIMARY,
  saving,
  onSave,
  title,
  subTitle,
}) => {
  const [color, setColor] = useState(existingColor);

  const handleChange = (color) => {
    setColor(color);
  };

  const handleSave = () => {
    onSave(color, handleClose);
  };

  const handleClose = () => {
    setColor(existingColor);
    onClose();
  };

  // Sync the color with the existing color
  useEffect(() => {
    setColor(existingColor);
  }, [existingColor]);

  return (
    <AppModal
      open={open}
      onClose={handleClose}
      title={title}
      content={
        <>
          <div className="mb-4 font-weight-500" style={{ fontSize: 14 }}>
            {subTitle}
          </div>
          <AppColorPicker title="Color" value={color} onChange={handleChange} />
        </>
      }
      onConfirm={handleSave}
      submitting={saving}
      confirmButtonText="Save"
      cancelButtonText="Cancel"
    />
  );
};

export default ColorModal;
